export function replaceAllUrlPhoto(content) {
  const stringContent = JSON.stringify(content);
  const result = stringContent.replace(
    /https:\/\/qoala-web-cms.s3.ap-southeast-1.amazonaws.com\//g,
    'https://cdn-qoala-media.qoala.app/'
  );
  return JSON.parse(result);
}
